import type { ChatScenarioData } from "@ui/components/core/ChatScenario";

/** Default scripted preview when CMS does not provide a chat scenario. */
export const speechEngineHelpScenario: ChatScenarioData = {
  id: "speech-engine-preview-default",
  messages: [
    {
      id: "a-1",
      role: "assistant",
      loadingBeforeMs: 700,
      parts: [
        {
          type: "text",
          content:
            "Hey — I'm El, your Speech Engine guide. Whether you're adding voice to an existing chat agent or starting fresh, I can help you get there. What are you building?",
        },
      ],
    },
    {
      id: "u-2",
      role: "user",
      loadingBeforeMs: 900,
      parts: [
        {
          type: "text",
          content:
            "We already have a text chat agent running on our own server. We want to add voice to it without rewriting the LLM logic.",
        },
      ],
    },
    {
      id: "a-3",
      role: "assistant",
      loadingBeforeMs: 750,
      parts: [
        {
          type: "text",
          content:
            "That's exactly the use case Speech Engine is built for. You keep your server, your LLM, your conversation routing — we just add the voice layer. ElevenLabs handles speech-to-text and text-to-speech; your backend stays in control.",
        },
      ],
    },
    {
      id: "u-4",
      role: "user",
      loadingBeforeMs: 800,
      parts: [
        {
          type: "text",
          content: "How does it actually work under the hood?",
        },
      ],
    },
    {
      id: "a-5",
      role: "assistant",
      loadingBeforeMs: 800,
      parts: [
        {
          type: "tool",
          name: "simple",
          data: {
            loadingText: "Loading Speech Engine architecture…",
            successText: "How it works — WebSocket flow, transcript delivery, and LLM streaming.",
          },
        },
        {
          type: "text",
          content:
            "Each conversation is a WebSocket connection between the browser and ElevenLabs. The user speaks → we transcribe it and send the transcript plus conversation history to your server → your server queries the LLM and streams the response back → we convert it to speech and play it in the browser.",
        },
      ],
    },
    {
      id: "u-6",
      role: "user",
      loadingBeforeMs: 850,
      parts: [
        {
          type: "text",
          content: "We're using OpenAI. Will the SDK handle the streaming response format for us?",
        },
      ],
    },
    {
      id: "a-7",
      role: "assistant",
      loadingBeforeMs: 700,
      parts: [
        {
          type: "text",
          content:
            "Yes — the SDK has built-in stream extraction for OpenAI (both Chat Completions and Responses API), Anthropic, and Google Gemini. You just pass the stream object directly; we handle chunking and text extraction. For any other provider you can pass a plain string or an async iterable.",
        },
      ],
    },
    {
      id: "u-8",
      role: "user",
      loadingBeforeMs: 750,
      parts: [
        {
          type: "text",
          content: "What happens if the user interrupts the agent mid-sentence?",
        },
      ],
    },
    {
      id: "a-9",
      role: "assistant",
      loadingBeforeMs: 700,
      parts: [
        {
          type: "text",
          content:
            "Interruption handling is built in. The moment we detect the user speaking over the agent, the SDK sends an AbortSignal to cancel the in-flight LLM request on your server and stops playback immediately — no partial sentences, no awkward overlap. You don't write any of that logic yourself.",
        },
      ],
    },
    {
      id: "u-10",
      role: "user",
      loadingBeforeMs: 900,
      parts: [
        {
          type: "text",
          content: "Our backend is Node.js — Express specifically. Does that work?",
        },
      ],
    },
    {
      id: "a-11",
      role: "assistant",
      loadingBeforeMs: 750,
      parts: [
        {
          type: "text",
          content:
            "Express is a great fit. You can attach Speech Engine to your existing HTTP server in a few lines. Fastify and plain Node.js http.createServer() work too. On the client side, the JavaScript SDK handles the WebSocket lifecycle, turn-taking, and audio — your Next.js frontend just initialises the session.",
        },
        {
          type: "tool",
          name: "simple",
          data: {
            loadingText: "Fetching quickstart for Express + Next.js…",
            successText: "JavaScript SDK quickstart — Express server setup and browser client.",
          },
        },
      ],
    },
    {
      id: "u-12",
      role: "user",
      loadingBeforeMs: 800,
      parts: [
        {
          type: "text",
          content: "This sounds like exactly what we need. How is it different from ElevenAgents?",
        },
      ],
    },
    {
      id: "a-13",
      role: "assistant",
      loadingBeforeMs: 650,
      parts: [
        {
          type: "text",
          content:
            "ElevenAgents is fully hosted — ElevenLabs provides the LLM, knowledge base, tools, and conversation logic. Speech Engine is for teams who want to bring their own model and keep full control over context management, tool calling, and routing. You own the intelligence; we add the voice.",
        },
      ],
    },
  ],
};
